export default __webpack_public_path__ + "static/inter-semibold-webfont-7867391695eb746d0e722446315d77e0.woff2";